import React from 'react';

export interface McpDetailHeaderField {
  key: string;
}

interface McpDetailBodyProps {
  url?: string;
  headers?: McpDetailHeaderField[];
}

// Full-detail MCP listing view — URL plus header key names (never values, same
// convention as everywhere else header values are kept out of the UI). Used by
// MarketplaceDetailModal, ToolDetailPanel, and InstalledToolDetail so a standalone
// mcp_server listing gets the same "no redaction" treatment as Agent and Skill.
const McpDetailBody: React.FC<McpDetailBodyProps> = ({ url, headers }) => {
  const headerKeys = (headers ?? []).map(h => h.key).filter(Boolean);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {url && (
        <div>
          <div className="mt-detail-field-label">MCP Server URL</div>
          <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>{url}</span>
        </div>
      )}
      {headerKeys.length > 0 && (
        <div>
          <div className="mt-detail-field-label">MCP Headers</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {headerKeys.map(k => (
              <span key={k} style={{
                background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.28)',
                color: '#60a5fa', fontSize: 12, padding: '4px 10px', borderRadius: 7,
              }}>
                {k}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default McpDetailBody;
